import { Book } from "../components/Book/Book"

export const BookPage = () => {
    return <Book />
}